/* eslint-disable no-unused-vars */
import React from 'react'
import { useTranslation } from 'next-i18next'
import { useAppDispatch } from 'src/app/hooks'
import { CustomModal, CustomTitle } from 'src/components'
import { resetPurchaseOperationSuccess } from 'src/features'

interface BrokerageErrorModalProps {
  isModalVisible: boolean
  setIsModalVisible: (value: boolean) => void
  error: {
    type?: 'COVER_ERROR' | 'STOCK_ERROR'
    projectName?: string
    stock?: number
    projectStock?: number
  }
}

const BrokerageErrorModal: React.FC<BrokerageErrorModalProps> = ({ isModalVisible, setIsModalVisible, error }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()


  const handleCancel = () => {
    dispatch(resetPurchaseOperationSuccess())
    setIsModalVisible(false)
  }

  const errorLabel = {
    COVER_ERROR: t('admin.Brokerage.ModalCoverError'),
    STOCK_ERROR: t('admin.Brokerage.ModalErrorContent', { stock: error?.stock, projectStock: error?.projectStock })
  }[error?.type] || ''

  return <CustomModal
    title={t('admin.Brokerage.ModalErrorTitle', { projectName: error?.projectName })}
    footer={null}
    open={isModalVisible}
    onCancel={handleCancel}
  >
    <CustomTitle label={errorLabel} />
  </CustomModal>
}
export default BrokerageErrorModal
